import PropTypes from 'prop-types';
import MuiDialogContent from '@mui/material/DialogContent';

/**
 * Renders a <DialogContent /> component.
 * @param {object} props - Any unaccounted properties will be available from restContentProps.
 * @param {Array} props.children
 * @returns {React.Component}
 */

export const DialogContent = ({ children, ...restContentProps }) => (
  <MuiDialogContent
    sx={{
      p: {
        xs: 2,
        sm: 4,
      },
    }}
    {...restContentProps}
  >
    {children}
  </MuiDialogContent>
);

DialogContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
